import React from 'react';
import styled, { css } from 'styled-components';

import logoInicioApp from '../images/logosinfondo.png';
import imgInpMenuMovil from '../images/iconos/menuBars.svg';

const HeaderInicio = ({
  openServicios,
  inpAbrirMenu,
  setinpAbrirMenu,
  openParcelas,
  openInicio,
  openNosotros
}) => {

  const abrirMenuMovil = (e) => {
    setinpAbrirMenu(e.target.checked)
  }
    return (
        <HeaderCSS
          inpAbrirMenu = { inpAbrirMenu }
          >
         <div>
           <img src = {logoInicioApp} alt = "/"/>
         </div>
         <h1>COMPAÑIA GESTORA DE INVERSIONES EN BIENES RAÍCES</h1>
         <main className= "menuInicioCSS">
           <button className="btnMenuInicioCSS" onClick = { openInicio }>Inicio</button>
           <button className="btnMenuInicioCSS" onClick={ openServicios }>Servicios</button>
           <button className="btnMenuInicioCSS" onClick = { openParcelas }>Parcelas</button>
           <button className="btnMenuInicioCSS" onClick = { openNosotros }>Nosotros</button>
         </main>
         <main className= " menuInicioMovilCSS">
           <label htmlFor="inpMenuMovil" className = "labelMenuMovil" onClick = {abrirMenuMovil}>
           <input
              onChange = {abrirMenuMovil}
              checked = { inpAbrirMenu }
              id = "inpMenuMovil" 
              type = "checkbox" 
              name = "inpMenu"/>
           <img src = {imgInpMenuMovil} alt = "/"/>
           </label>
         </main>
         <div className="divMenuMovil">
           <li onClick = { openInicio }>Inicio</li>
           <li onClick = { openServicios }>Servicios</li>
           <li onClick = { openParcelas }>Parcelas</li>
           <li onClick = { openNosotros }>Nosotros</li>
           <div className="div2MenuMovil">
              <img id ="img2MenuMovil" src = {logoInicioApp} alt = "/"/>
           </div>
         </div>
       </HeaderCSS>
    )
}
export default HeaderInicio;

const HeaderCSS = styled.header`
  position: relative;
  position: fixed;
  width: 100%;
  height: 12%;
  z-index:6;
  margin: 0%;
  top: 0%;
  background-color: #003333;
  box-shadow: 3px 3px 8px 3px rgb(228, 185, 7);
  ${'' /* //320, 480  landscape, 768, 1024, 1200 */}
  @media (max-width: 320px) {
      width:100%;
  }
  @media (max-width: 480px) {
      width:100%;
  }

  div {
    width: 10%;
    height: 100%;
    margin-left: 5%;
    ${'' /* //320, 480  landscape, 768, 1024, 1200 */}  
    @media (max-width: 1200px) {
      width:15%;
      margin-left:0%;
    }
    @media (max-width: 1024px) {
      width:18%;
      margin-left:0%;
    }
    @media (max-width: 768px) {
      margin-left:0%;
      width:20%;
    }
    @media (max-width: 480px) {
      margin-left:0%;
      width:28%;
    }
    @media (max-width: 320px) {
      margin-left:0%;
      width:30%;
    }
  }
  
  div img{
    width:70%;
    height: 100%;
  }
  
  h1 {
    position: absolute;
    font-size: 170%;
    top: 0%;
    margin: 0;
    height: 60%;
    left: 15%;
    right: 15%;
    padding: 1%;
    color: #fff;
    font-family: widen latin;
    @media (max-width: 1200px) {
      font-size: 150%;
      top: 10%;
    }
    @media (max-width: 1024px) {
      font-size: 140%;
      top: 10%;
      left: 20%;
    }
    @media (max-width: 768px) {
      font-size: 110%;
      top: 10%;
      left: 20%;
    }
    @media (max-width: 480px) {
      font-size: 80%;
      top: 10%;
      left: 21%;
      height:60%;
    }
    @media (max-width: 320px) {
      font-size: 80%;
      top: 10%;
      left: 24%;
      height:60%;
      width: 63%;
    }
  }
  
  .menuInicioCSS {
    display: block;
    position: absolute;
    top: 100%;
    height: 50%;
    left: 30%;
    right: 30%;
    background-color:#003333;
    box-shadow: 3px 3px 3px 3px #fff;
    z-index:5;
    @media (max-width: 938px) {
     display: none;
    }
  }

  .btnMenuInicioCSS {
    margin: 1%;
    z-index:6;
    border: none;
    border-left: 1px solid #fff;
    border-right: 1px solid #fff;
    margin-left: 5%;
    height: 75%;
    padding-left: 3%;
    padding-right: 3%;
    border-radius: 10px;
    left: 0%;
    position: relative;
    font-size: 15px;
    font-weight: 800;
    color: #fff;
    text-decoration: underline;
    background-color: #003333;
    font-family: widen latin;
    cursor: pointer;
    &:hover {
      background-color: #fff;
      color: #003333;    
    }
    &:focus {
      background-color: #fff;
      color: #003333;    
    }
    @media(max-width:1040px) {
      margin-left: 3%;
    }
  }
  .divMenuMovil {
    color:green;
    display: none;
    position: absolute;
    left: 0%;
    margin: 0;
    width: 100%;
    height:730%;
    background-color: #bf930d;
    transition: all 1s;
    transform: translateX(-100%);
    ${props => props.inpAbrirMenu === true && css `
      transform: translateX(0%);
    `}
    @media (max-width:400px) {
      height:450x;
    }
    
    .div2MenuMovil {
        width: 100%;
        height: 56%;
        margin: 0%;
        background-color:#003333;
        @media (max-width:400px) {
          height:60%;
        }
      }

      #img2MenuMovil {
        display:none;
        @media  (max-width: 938px) {
          display: block;
          width: 70%;
          height: 90%;
          left:15%;
          position: relative;
        }
        @media  (max-width: 540px) {
          display: block;
          width: 90%;
          height:90%;
          left:5%;
          position: relative;
        }
        @media  (max-width: 450px) {
          display: block;
          width: 70%;
          left:15%;
          position: relative;
        }
        @media  (max-width: 360px) {
          display: block;
          width: 90%;
          height: 85%;
          left:3%;
          position: relative;
        }
        @media  (max-width: 290px) {
          display: block;
          width: 100%;
          left:0%;
          position: relative;
        }
      }
    li {
      color:white;
      font-family: widen latin;
      background-color: #003333;
      position: relative;
      text-align: left;
      margin: 0%;
      border: 1px solid #bf930d;
      padding-left: 10%;
      padding-top: 2%;
      height: 10%;
      font-size: 40px;
      cursor: pointer;
      @media(max-width: 320px) {
      font-size: 30px;
    }
      &:hover {
        background-color: #bf930d;
      }
    }
    @media(max-width: 938px) {
     display: block;
    }
  }

  /* MENU MOVIL */

  .menuInicioMovilCSS {
      display: none;
    @media (max-width: 938px) {
      display: block;
      position: absolute;
      top: 25%;
      right: 8%;
      width: 2%;
      height: 50%;
      box-shadow: 3px 0px 30px rgba(163, 163, 163, 1);
      #inpMenuMovil {
        display: none;
      }
      img {
        height: 100%;
      }
      ${props => props.inpAbrirMenu === true && css `
        box-shadow: 3px 0px 30px  #bf930d;
      `}      
    }
  }
`;
